import React from "react";
import moment from "moment";
import { FaInfoCircle } from "react-icons/fa";

export const depositStatusChip = (status) => {
  switch (status) {
    case "PENDING":
      return {
        text: "Pending approval",
        bgColor: "#FFE0A3",
        textColor: "#705010",
      };

    case "APPROVED":
      return {
        text: "Approved",
        bgColor: "#EAFBF1",
        textColor: "#1D7C3D",
      };

    case "REJECTED":
      return {
        text: "Rejected",
        bgColor: "#FDEAEA",
        textColor: "#C73737",
      };

    default:
      return { text: status };
  }
};

export const StatusChip = ({ status }) => {
  let styles = {
    text: status || "-",
    bgColor: "#F5F5F5",
    textColor: "#757575",
  };

  // Normalize string to handle "APPROVED" vs "Approved"
  const normalizedStatus = String(status).toUpperCase();

  switch (normalizedStatus) {
    case "APPROVED":
      styles = { text: "Approved", bgColor: "#E4F6EA", textColor: "#299F59" };
      break;
    case "IN_PROGRESS":
    case "L1_PENDING":
    case "PENDING":
    case "IN PROGRESS":
      styles = {
        text: "In Progress",
        bgColor: "#FCEFD3",
        textColor: "#C47F00",
      };
      break;
    case "ACTION_NEEDED":
    case "ACTION NEEDED":
      styles = {
        text: "Action Needed",
        bgColor: "#FFE9E9",
        textColor: "#D64545",
      };
      break;
    case "REJECTED":
      styles = { text: "Rejected", bgColor: "#FFEBEB", textColor: "#BD3131" };
      break;
    default:
      // Keep default grey for unknown statuses
      break;
  }

  return (
    <span
      style={{
        backgroundColor: styles.bgColor,
        color: styles.textColor,
        fontSize: "12px",
        padding: "4px 10px",
        borderRadius: "16px",
        fontWeight: 600,
        display: "inline-block",
        whiteSpace: "nowrap",
      }}
    >
      {styles.text}
    </span>
  );
};

function formatDate(timestamp) {
  if (!timestamp) return "";

  return moment(timestamp).format("DD MMM");
}

export function transformDepositData(item) {
  return {
    id: item.businessAreaValue || "",
    branchCode: item.cashierOffice ?? "",
    cashierOffice: item.cashierOffice || "",
    branchName: `${item.businessAreaValue}`,
    officeType: `Cashier's office ${item?.cashierOffice || "-"}`,
    ownership: "",
    daysLeftToDeposit: item.daysRemaining,

    cashInHand: {
      amount: item.undepositTotalAmount,
      receiptsCount: item.undepositCount,
      fromDate: formatDate(item.undepositEarliestDate),
      toDate: formatDate(item.undepositLatestDate),
    },

    depositInTransit: {
      amount: item.depositTotalAmount,
      hasDeposits: item.depositCount > 0,
      fromDate: formatDate(item.depositEarliestDate),
      toDate: formatDate(item.depositLatestDate),
      status: item.pendingStatus,
      receiptsCount: item.depositCount,
    },

    status: item.pendingStatus,
  };
}

export const getDaysChip = (daysLeft) => {
  if(daysLeft===null || daysLeft===undefined){
    return null;
  }
  if (daysLeft < 0)
    return {
      label: (
        <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <FaInfoCircle />
          Overdue
        </span>
      ),
      bgColor: "#DC2804",
      textColor: "#FFFFFF",
    };

  if (daysLeft === 0)
    return {
      label: "Due today",
      bgColor: "#F9D9D7",
      textColor: "#B32306",
    };

  if (daysLeft === 1)
    return {
      label: "1 Day left",
      bgColor: "#F9D9D7",
      textColor: "#B32306",
    };

  if (daysLeft === 2)
    return {
      label: "2 Days left",
      bgColor: "#F9D9D7",
      textColor: "#B32306",
    };

  return {
    label: `${daysLeft} Days left`,
    color: "default",
  };
};

export const getMapBusinessAreasById = (businessAreas = []) => {
  return businessAreas.reduce((acc, item) => {
    acc[item.value] = item?.businessAreaDesc;
    return acc;
  }, {});
};

export const getLocationWithDescription = (locations, businessAreas) => {
  const mapBusinessAreasById = getMapBusinessAreasById(businessAreas);
  return locations.map((item) => ({
    ...item,
    businessAreaDes: mapBusinessAreasById[item.id],
  }));
};

export const hasSameEffectiveDate = (receipts) => {
  const uniqueDates = new Set(
    receipts.map((r) => moment(r.receiptDate).format("DD-MM-YYYY"))
  );
  return uniqueDates.size === 1;
};
const PHASE_ONE_LIVE_BRANCHES  = [
  "RJ696",
  "UP666",
  "DW087",
  "JP001",
  "JP002",
  "DL699",
  "DL487",
  "DL477",
  "DL482",
  "DL738",
  "SE003",
  "SE004",
  "SE606",
  "DL695",
  "FB019",
  "UP789",
  "GN009",
  "UP727",
  "HR686",
  "HR685",
  "HR704",
  "ND008",
  "ND086",
  "DL483",
  "PL037",
  "DL583"
];

export const LIVE_BRANCHES = [
  ...PHASE_ONE_LIVE_BRANCHES,
];
export const LIVE_BRANCHES_SET = new Set(LIVE_BRANCHES);

export const isLiveBranch = (businessArea) => {
  return true;
  return LIVE_BRANCHES_SET.has(businessArea?.label);
};

export const replaceEmptyWithNull = (obj) => {
  const newObj = {};
  Object.keys(obj).forEach((key) => {
    newObj[key] = obj[key] === "" ? null : obj[key];
  });
  return newObj;
};
